import { Close } from '@mui/icons-material';
import { IconButton, MenuItem } from '@mui/material';
import * as React from 'react';
import { FaSort, FaSortDown, FaSortUp } from 'react-icons/fa';
import { RiSearchLine } from 'react-icons/ri';
import { VdsSelect, VdsTextField } from '..';
import { Filters, SortingTypes } from './VdsTable';

/** Traduzioni di default per le sezioni della tabella */
const tsl = {
    search: 'Search'
}

interface ConditionalSortingProps {
    order: SortingTypes;
    field: string;
    submit: (filters: Partial<Filters>) => void;     // Evento di applicazione del filtro
}

export const ConditionalSorting: (props: ConditionalSortingProps) => React.ReactElement = (props) => {

    if (props.order === 'Asc')
        return (
            <IconButton
                size="small"
                style={{ fontSize: '16px' }}
                onClick={() => {
                    props.submit({
                        sorting: {
                            field: props.field,
                            order: 'Desc'
                        }
                    });
                }}
            >
                <FaSortDown style={{ fill: '#005075' }} />
            </IconButton>
        );

    if (props.order === 'Desc')
        return (
            <IconButton
                size="small"
                style={{ fontSize: '16px' }}
                onClick={() => {
                    props.submit({
                        sorting: {
                            field: props.field,
                            order: 'Asc'
                        }
                    });
                }}
            >
                <FaSortUp style={{ fill: '#005075' }} />
            </IconButton>
        );

    return (
        <IconButton
            size="small"
            style={{ fontSize: '16px' }}
            onClick={() => {
                props.submit({
                    sorting: {
                        field: props.field,
                        order: 'Asc'
                    }
                });
            }}
        >
            <FaSort style={{ fill: '#005075' }} />
        </IconButton>
    );
}

interface TextFilterProps {
    id: string,
    search?: string,
    filter: {
        filter: string | null,
        field: string;
    },
    submit: (filters: Partial<Filters>) => void;     // Evento di applicazione del filtro
}

export const TextFilter: (props: TextFilterProps) => React.ReactElement = (props) => {

    const [tempFilter, setTempFilter] = React.useState<string>(props.filter.filter || '');
    const [filter, setFilter] = React.useState<string>(props.filter.filter || '');

    React.useEffect(() => {

        setTempFilter(props.filter.filter || '');
        setFilter(props.filter.filter || '');

    }, [props.filter.filter]);

    const onKeyPressEventHandler = (event: any) => {

        if (event.key === 'Enter') {

            setFilter(tempFilter);
            props.submit({
                filters: [{
                    field: props.filter.field,
                    filter: tempFilter.trim()
                }]
            })
        }
    };

    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ flexGrow: 1 }}>
                <VdsTextField
                    size="small"
                    placeholder={props?.search || tsl.search}
                    sx={{
                        color: '#005075',
                        border: 'unset',
                        fontFamily: 'Roboto!important',
                        marginRight: '0px!important',
                        paddingRight: '0px!important',
                        ':hover': {
                            border: 'unset!important',
                        },
                        '.MuiTouchRipple-root': {
                            cursor: 'pointer!important',
                        },
                        '.MuiInput-root': {
                            marginLeft: '2px',
                            fontSize: '14px',
                            fontWeight: '500'
                        }
                    }}
                    onKeyPress={onKeyPressEventHandler}
                    onBlur={(ev) => {

                        if ((ev.relatedTarget as any)?.dataset?.targetId !== props.id) {

                            setTempFilter(filter);
                        }
                    }}
                    onChange={(ev) => {

                        setTempFilter(ev?.currentTarget?.value || '')
                    }}
                    value={tempFilter}
                    collapse
                />
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                {filter && (
                    <IconButton
                        data-target-id={props.id}
                        onClick={() => {

                            setFilter('');
                            setTempFilter('');
                            props.submit({
                                filters: [{
                                    field: props.filter.field,
                                    filter: ''
                                }]
                            })
                        }}
                        style={{ padding: 0 }}
                    >
                        <Close style={{ fill: '#0090D1', fontSize: '23px' }} />
                    </IconButton>
                )}
                <IconButton
                    data-target-id={props.id}
                    onClick={() => {

                        setFilter(tempFilter.trim());
                        props.submit({
                            filters: [{
                                field: props.filter.field,
                                filter: tempFilter.trim()
                            }]
                        })
                    }}
                    style={{ borderRadius: 'unset' }}
                >
                    <RiSearchLine style={{ fill: '#0090D1' }} />
                </IconButton>
            </div>
        </div>
    );
}

interface SelectFilterProps {
    options: { text: string, value: string }[],
    filter: {
        filter: string | null,
        field: string;
    },
    submit: (filters: Partial<Filters>) => void;     // Evento di applicazione del filtro
}

export const SelectFilter: (props: SelectFilterProps) => React.ReactElement = (props) => {

    const [tempFilter, setTempFilter] = React.useState<string>(props.filter.filter || '');

    React.useEffect(() => {

        setTempFilter(props.filter.filter || '');

    }, [props.filter.filter]);

    return (
        <VdsSelect
            value={tempFilter}
            sx={{
                border: 'unset',
                fontFamily: 'Roboto!important',
                ':hover': {
                    border: 'unset!important',
                },
                color: tempFilter === '' ? '#9DA6AD' : '#005075'
            }}
            onChange={(ev: any) => {
                setTempFilter(ev.target.value || '');
                props.submit({
                    filters: [{
                        field: props.filter.field,
                        filter: ev.target.value || ''
                    }]
                })
            }}
            displayEmpty
            collapse
        >
            {props.options.map(({ text, value }, i) => {
                return (
                    <MenuItem key={i} value={value || ''} sx={{
                        fontFamily: 'Roboto!important',
                        fontSize: '14px'
                    }}>{text}</MenuItem>
                );
            })}
        </VdsSelect>
    );
}


